import styled from 'styled-components';

import colors from '../../styles/colors';

const Link = styled.a`
  color: ${colors.shades.secondary2};
  text-decoration: underline;
  overflow-wrap: anywhere;

  &:hover {
    text-decoration: none;
  }
`;

export { Link };
